import React from "react";
import BaseComponent from "../baseComponent";
import UserCatalogueComponent from "./userCatalogueComponent";
import Utility, {dispatchAction} from "../../utility";
import {connect} from "react-redux";
import catalogueService from "../../services/catalogue";
import {pathConstants} from "../../constants";
import {history} from '../../managers/history'

export class Catalogue extends BaseComponent {
    constructor(props) {
        super(props);
        this.state = {
            orderList: [],
            selectedOrder: null,
        }
    }

    async componentDidMount() {
        if (window.location.pathname.split('/').length > 3) {
            const selectedOrder = await catalogueService.getCatalogue(window.location.pathname.split('/')[3])
            this.setState({selectedOrder})
        }
        await this.refreshOrderList()
    }

    onOrderClicked = (orderObj) => {
        this.setState({selectedOrder: orderObj})
        history.push(pathConstants.DASHBOARD_MENU.CATALOGUE + "/" + orderObj?._id)
        window.location.reload();
    };
    refreshOrderList = async () => {
        // this.props.dispatchAction(eventConstants.SHOW_LOADER);
        let [err, res] = await Utility.parseResponse(catalogueService.getUserCatalogue(),);
        // this.props.dispatchAction(eventConstants.HIDE_LOADER);
        if (!res || err)
            return Utility.apiFailureToast("Unable to fetch order list");
        res.sort((a, b) => new Date(b.modifiedOn).getTime() - new Date(a.modifiedOn).getTime());
        this.setState({orderList: res})
    }

    render() {
        return (
            <UserCatalogueComponent
                state={this.state}
                refreshOrderList={this.refreshOrderList}
                onOrderClicked={this.onOrderClicked}
            />
        );
    }
}

const mapStateToProps = (state) => {
    return {user: state.user};
};

export default connect(mapStateToProps, {dispatchAction})(Catalogue);
